
import AppSearchBrowse from "@/components/browse/SearchBrowse.vue";
import { Contact } from "@/models/base";
import { BrowseService } from "@/services/browse-service";
import { IBrowseBaseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import { SupplierService } from "@/services/supplier-service";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { View } from "@/models/view";

export default Vue.extend({
	computed: {
		dataSource():IBrowseBaseDataSource<Contact> {
			return {
				getSettings: () => BrowseService.getBrowse(2),
				getElements: SupplierService.getContacts.bind(SupplierService),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return SupplierService.getTotals(view);
				},
				browseName: "Suppliers",
				modelName: "Contact"
			};
		}
	},
	methods: {
		onClick(contact:Contact) {
			this.$emit("click", contact);
		}
	},
	components: {
		AppSearchBrowse
	}
});
